export enum NetworkNamespace {
  n3 = 'N3',
  x = 'X',
}
